(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fxn-m200-technology"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var link = event.target.closest('[data-fxnt-cta]');
  if (!link) return;
  var privacy = window.Shopify && window.Shopify.customerPrivacy;
  if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'fxn_technology_cta_click', {
      cta_type: link.dataset.fxntCta,
      cta_placement: link.dataset.fxntPlacement,
      page_path: window.location.pathname,
      transport_type: 'beacon'
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fxn-v3-solution"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (root) => {
    root.querySelectorAll('[data-capsule-loop]').forEach((figure) => {
      if (figure.dataset.ready) return;
      figure.dataset.ready = 'true';
      const video = figure.querySelector('video');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      video.muted = true;
      video.defaultMuted = true;
      const start = () => {
        if (!reduced.matches && !document.hidden) {
          video.play().catch(() => { video.controls = true; });
        }
      };
      if (reduced.matches) { video.autoplay = false; video.pause(); }
      else start();
      video.addEventListener('loadeddata', start, { once: true });
      window.addEventListener('pageshow', start);
      reduced.addEventListener('change', () => {
        video.autoplay = !reduced.matches;
        if (reduced.matches) video.pause(); else start();
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup(document), { once: true });
  } else setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-applications"] && !Shopify.designMode) return;
  try {
    
  if (!window.fxnApplicationCardsBound) {
    window.fxnApplicationCardsBound = true;
    document.addEventListener('click', function(event) {
      const card = event.target.closest('.fxn-apps__card[data-application-category]');
      if (!card || window.Shopify?.designMode) return;
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy || !privacy.analyticsProcessingAllowed() || typeof window.gtag !== 'function') return;
      window.gtag('event', 'application_card_click', {
        application_category: card.dataset.applicationCategory,
        product_name: card.dataset.applicationProduct,
        link_url: card.getAttribute('href')
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
